import img1 from "../images/khoj-images/image 484.png";
import img2 from "../images/khoj-images/image 488.png";
import img3 from "../images/khoj-images/image 489.png";
import img4 from "../images/khoj-images/image 490.png";
import img5 from "../images/khoj-images/image 484.png";
import img6 from "../images/khoj-images/image 488.png";
import img7 from "../images/khoj-images/image 489.png";
import img8 from "../images/khoj-images/image 490.png";
import img9 from "../images/khoj-images/image 490.png";





const dataCandi = [
    {
        id: 1,
        avt: img1,
        unit: 'Entry Level Network Administrator',
        name:'Marvin McKinney',
        cate: 'Available now',
        map: 'New York',
        price: '8000'
    },
    {
        id: 2,
        avt: img1,
        unit: 'Computational Wizard',
        name:'Arlene McCoy',
        cate: 'Available now',
        map: 'Tokyo, Japan',
        price: '40111'
    },
    {
        id: 3,
        avt: img2,
        unit: 'Computer Support Specialist',
        name:'Floyd Miles',
        cate: 'Available now',
        map: 'Tokyo, Japan',
        price: '3000'
    },
    {
        id: 4,
        avt: img3,
        unit: 'Computer Support Specialist',
        name:'Annette Black',
        cate: 'Available now',
        map: 'Tokyo, Japan',
        price: '5000'
    },
    {
        id: 5,
        avt: img4,
        unit: 'Digital Overlord',
        name:'Maverick Nguyen',
        cate: 'Available now',
        map: 'Tokyo, Japan',
        price: '5000'
    },
    {
        id: 6,
        avt: img5,
        unit: 'Computer Hardware Engineer',
        name:'Kathryn Murphy',
        cate: 'Available now',
        map: 'Tokyo, Japan',
        price: '400'
    },
    {
        id: 7,
        avt: img6,
        unit: 'C3PO – Chief Power Plugs & Patches Officer',
        name:'Guy Hawkins ',
        cate: 'Available now',
        map: 'Tokyo, Japan',
        price: '300'
    },
    {
        id: 8,
        avt: img7,
        unit: 'Database Administrator',
        name:'Courtney Henry',
        cate: 'Available now',
        map: 'Tokyo, Japan',
        price: '400'
    },
    {
        id: 9,
        avt: img8,
        unit: 'Sales Engineer',
        name:'Brooklyn Simmons',
        cate: 'Available now',
        map: 'Tokyo, Japan',
        price: '430'
    },
    {
        id: 10,
        avt: img9,
        unit: 'Chief Geek',
        name:'Cameron Williamson',
        cate: 'Available now',
        map: 'Tokyo, Japan',
        price: '200'
    },


]

export default dataCandi;